export const getMatches = (pred) => (theObject) => {
    let result = null;

    if (theObject instanceof Array) {
        for (let i = 0; i < theObject.length; i++) {
            result = getMatches(pred)(theObject[i]);
            if (result) {
                break;
            }
        }
    } else {
        if (pred(theObject)) {
            return theObject;
        }
        for (const prop in theObject) {
            if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
                result = getMatches(pred)(theObject[prop]);
                if (result) {
                    break;
                }
            }
        }
    }

    return result;
};

export const removeEmptyObjects = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;

    return Object.entries(obj).reduce((acc, [key, value]) => {
        // Check if value is an object, not null, and has no keys
        const isEmptyObject = value
            && typeof value === 'object'
            && !Array.isArray(value)
            && Object.keys(value).length === 0;

        if (!isEmptyObject) {
            acc[key] = value;
        }

        return acc;
    }, {});
};
